import {BehaviorSubject} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {accountApi} from '@px/api/account';
import {authStatus$} from './auth';

export const subAccounts$ = new BehaviorSubject([]);

authStatus$
  .pipe(
    filter((authStatus) => authStatus === 'Login'),
    switchMap(() => accountApi.getChildrenBaseInfo())
  )
  .subscribe(({data}) => {
    if (data) {
      subAccounts$.next(data);
    }
  });
